/**
 * @generated SignedSource<<ab7e7f2459fb42c66c7dc6bbe97f9b9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineSectionListItem_RoutineSectionVersion$data = {
  readonly section: {
    readonly assignedTeam: {
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team">;
    } | null;
  };
  readonly title: string | null;
  readonly " $fragmentType": "RoutineSectionListItem_RoutineSectionVersion";
};
export type RoutineSectionListItem_RoutineSectionVersion$key = {
  readonly " $data"?: RoutineSectionListItem_RoutineSectionVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineSectionListItem_RoutineSectionVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineSectionListItem_RoutineSectionVersion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineSection",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "assignedTeam",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamIconCircleComponent_Team"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineSectionVersion",
  "abstractKey": null
};

(node as any).hash = "6922466f12457b3f3cdf752e317d8b09";

export default node;
